// Angular DOM
import {Component, ViewChild, TemplateRef} from "@angular/core";
// Angular Hooks
import {OnInit, AfterViewInit} from "@angular/core";
// Redux Store
import {Store} from "@ngrx/store";
import {SetPatientAction} from "../../actions";
// Models
import {Patient} from "../../models";
// Third Party Services
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
// Services
import {PatientService, UtilService} from "../../services";
import {Location} from "@angular/common";


@Component({
  selector: "app-patient-billing-modal",
  templateUrl: "./patient-billing-modal.component.html",
  styleUrls: ["./patient-billing-modal.component.scss"]
})
export class PatientBillingEditModalComponent implements OnInit, AfterViewInit {
  @ViewChild("content") template: TemplateRef<any>;

  public patient: Patient;
  public modalRef: any;
  public confirm: boolean = false;
  public editMode: boolean = true;
  public modalTitle: string = "Edit Patient Billing";

  private isAdminEdit: boolean = false;
  private patientId: number;

  // exit edit/* workflow
  private cancelPath: string = "../../";

  public backButtonText = "CANCEL";
  public requestPending: boolean = false;

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-billing",
    container: "app-patient-billing-modal",
    keyboard: false
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private patientService: PatientService,
    private store: Store<any>,
    private utilService: UtilService,
    private location: Location
  ) {
    this.store.select("patient").subscribe(patient => {
      this.patient = Object.assign({}, new Patient(), patient);
    });
  }

  ngOnInit() {
    this.route.parent.parent.parent.params.subscribe(params => {
      this.patientId = +params["id"];
    });

    this.route.parent.parent.data.subscribe(data => {
      if (data.isAdminEdit) {
        this.isAdminEdit = data.isAdminEdit;
        this.backButtonText = "BACK";

        // admin-portal does not have a /patients/:id path, only a /patients.  let's trim off that :id
        this.cancelPath = "../../../";
      }
    });

    // fix empty InsurancePolicies array
    if ( !this.patient.InsurancePolicies.length ) {
       this.patient.InsurancePolicies[0] = { BillTo: 'N/A'};
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  onFacilitySelect(event, elem) {
    this.patient.BillToText = event;
    this.patient.InsurancePolicies[0].BillTo = '';
    elem.focus();
  }

  clearFacilityField(){
    this.patient.BillToText = '';
  }

  onFacilityRadioButton(elem) {
    this.patient.InsurancePolicies[0].BillTo = '';
    elem.focus()
  }

  setConfirm() {
    this.confirm = false;
  }

  canSkip() {
    return !(
      this.editMode ||
      this.patient.BillToText ||
      this.patient.InsurancePolicies[0].BillTo ||
      this.patient.InsurancePolicies[0].Provider ||
      this.patient.InsurancePolicies[0].GroupNumber ||
      this.patient.InsurancePolicies[0].PlanNumber
    );
  }

  back() {
    if (this.isAdminEdit) {
      this.location.back();
    } else {
      this.cancel();
    }
  }

  update() {
    this.requestPending = true;
    if (this.patient.BillToText !== "" && this.patient.BillToText) {
      this.patient.InsurancePolicies[0].BillTo = this.patient.BillToText;
    }
    this.patientService.updatePatientBilling(this.patient).subscribe(() => {
      this.requestPending = false;
      this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
      this.cancel();
    });
  }

  cancel() {
    this.router.navigate([this.cancelPath], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-billing-modal/patient-billing-edit-modal.component.ts